import { Login } from "../Pages/Login";
import { Recover } from "../Pages/Recover";
import { RecoverUpdate } from "../Pages/RecoverUpdate";
import { Dashboard } from "../Pages/Dashboard";
import { UserPortal } from "../Pages/UserPortal";
import { NotFound } from "../Pages/NotFound";
import { GestionUsuarios } from "../Pages/GestionUsuarios"; 
import { CreateOrder } from "../Pages/CreateOrder"; 
import {Order } from "../Pages/Order";
import { UsersAdmins } from "../Pages/UsersAdmins";
import { Sadminlogin } from "../Pages/Sadminlogin";
import { Relation } from "../Pages/Relation";
import { Profile } from "../Pages/Profile";
import {AdmProfile} from "../Pages/AdmProfile";

const routes = [
  {
    title : "Relation",
    path : "/Relation",
    component : Relation,
  },
  {
    title: "AdmProfile",
    path: "/AdmProfile",
    component: AdmProfile,
  },
  {
    title: "Profile",
    path: "/Profile",
    component: Profile,
  },
  {
    title: "UsersAdmins",
    path: "/UsersAdmins",
    component: UsersAdmins,
  },
  {
    title: "Sadminlogin",
    path: "/Sadminlogin",
    component: Sadminlogin,
  },
  {
    title: "CreateOrder",
    path: "/CreateOrder",
    component: CreateOrder,
  },
  {
    title: "Order",
    path: "/Order",
    component: Order,
  },
  {
    title: "UserPortal",
    path: "/UserPortal",
    component: UserPortal,
  },
  {
    title: "NotFound",
    path: "/NotFound",
    component: NotFound,
  },

  {
    title: "GestionUsuarios",
    path: "/GestionUsuarios",
    component: GestionUsuarios,
  },
  {
    title: "Recover",
    path: "/Recover",
    component: Recover,
  },
  {
    title: "RecoverUpdate",
    path: "/RecoverUpdate/:id/:email",
    component: RecoverUpdate,
  },
  {
    title: "Dashboard",
    path: "/Dashboard",
    component: Dashboard,
  },
  {
    title: "Login",
    path: "/",
    component: Login,
  },

];

export default routes;
